export var ENTITY = "rentRegistrationDocuments";
export var REDUCER_KEY = "RENT_REGISTRATION_DOCUMENTS_V2";
export var BASE_PATH_ENTITY = "rent-registration-documents";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
